import * as React from 'react'
import { useWalletClient } from 'wagmi'
import { providers } from 'ethers'
import { Config, getConnectorClient } from '@wagmi/core'
import type { Account, Chain, Client, Transport } from 'viem'

export function walletClientToSigner(walletClient: any) {
    const { account, chain, transport } = walletClient
    const network = {
        chainId: chain?.id || 1,
        name: chain?.name,
        ensAddress: chain?.contracts?.ensRegistry?.address,
    }
    const provider = new providers.Web3Provider(transport, network)
    const signer = provider.getSigner(account.address)
    return signer
}

/** Hook to convert a viem Wallet Client to an ethers.js Signer. */
export function useEthersSigner({ chainId }: { chainId?: number } = {}) {
    const { data: walletClient } = useWalletClient({ chainId })
    return React.useMemo(
        () => (walletClient ? walletClientToSigner(walletClient) : undefined),
        [walletClient],
    )
}


export function clientToSigner(client: Client<Transport, Chain, Account>) {
  const { account, chain, transport } = client
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  }
  const provider = new providers.Web3Provider(transport, network)
  const signer = provider.getSigner(account.address)
  return signer
}

/** Action to convert a Viem Client to an ethers.js Signer. */
export async function getEthersSigner(
  config: any,
  { chainId }: { chainId?: number } = {},
) {
  const client: any = await getConnectorClient(config, { chainId })
  return clientToSigner(client)
}